import { APP_ROUTES } from '@/navigators/routes';

/**
 * Tab routes that render no rail/drawer entry of their own — their entries
 * live inside the More popup instead (see drawer-content.tsx). The routes
 * stay registered in app-tabs so the popup can jump to them; only their
 * nav-list tiles are suppressed.
 */
export const MORE_MENU_ABSORBED_ROUTES: ReadonlySet<string> = new Set([
  APP_ROUTES.Links,
  APP_ROUTES.StorefrontMicroProduct,
]);
